module.exports = {
  tripapp: {
    path: 'https://v2.holidayextras.co.uk/'
  },
  auth: {
    url: 'https://v2.holidayextras.co.uk/tripapp-rails/user/info',
    logout: 'https://v2.holidayextras.co.uk/tripapp-rails/users/sign_out.json?_method=delete'
  },
  userExists: {
    url: 'https://v2.holidayextras.co.uk/tripapp-rails/users/exists.json',
    token: '61b85d79-96bf-4bfe-9c33-7c78154ed3d6'
  }
}
